export const MINUTES_INTERVAL = 15
export const COLUMNS_PER_ROW = 6 // 6 slots per row for better utilization
export const FLEX_GAP = 8 // Reduced gap for tighter layout
